import { useSyncExternalStore } from 'react';

/**
 * Platí media query práve teraz? Pre rozloženia, ktoré sa nedajú prepnúť iba
 * CSS triedou — napríklad bočný panel namiesto sheetu: keby sa vykreslili
 * obe verzie a jedna sa skryla, detail leadu by sa načítal a zapisoval dvakrát.
 */
export const useMediaQuery = (query: string): boolean =>
  useSyncExternalStore(
    (notify) => {
      if (typeof window === 'undefined' || !window.matchMedia) return () => undefined;
      const list = window.matchMedia(query);
      list.addEventListener?.('change', notify);
      return () => list.removeEventListener?.('change', notify);
    },
    () => (typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(query).matches : false),
    () => false,
  );
